module.exports = __webpack_public_path__ + "static/media/nonRsvpGraphic.63a11811.png";